export const TELEMETRY_REPORTED_WINDOW = {
  Last5Days: 'Last5Days',
  Last30Days: 'Last30Days',
  Last90Days: 'Last90Days',
  SinceStatusUpdated: 'SinceStatusUpdated',
};

// How far back an app's reported files are read. Since the status was updated never reaches past
// the 90 days telemetry keeps.
const TELEMETRY_REPORTED_WINDOW_MAPPING = [
  { value: TELEMETRY_REPORTED_WINDOW.Last5Days, label: 'Last 5 days' },
  { value: TELEMETRY_REPORTED_WINDOW.Last30Days, label: 'Last 30 days' },
  { value: TELEMETRY_REPORTED_WINDOW.Last90Days, label: 'Last 90 days' },
  { value: TELEMETRY_REPORTED_WINDOW.SinceStatusUpdated, label: 'Last updated' },
];

const find = value => TELEMETRY_REPORTED_WINDOW_MAPPING.find(item => item.value === value);

export const getTelemetryReportedWindowLabel = value => find(value)?.label ?? '';

export const getTelemetryReportedWindowOptions = () =>
  TELEMETRY_REPORTED_WINDOW_MAPPING.map(({ value, label }) => ({ value, label }));
